import {createApp} from 'vue'
import ProfileDeleted from './ProfileDeleted'

const el = '.kb-component--profile-deleted'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ProfileDeletedDOM)=>{
            const component = createApp(ProfileDeleted).use(Store)
            component.mount(ProfileDeletedDOM)
        })
    }
}